import { ColorProvider } from './chart-color-provider';

export const CHART_SMALL_FONT_WEIGHT = 500;

export const COMMON_CHART_OPTIONS = {
    animation: false,
    textStyle: {
        fontFamily: `Roboto, Noto Sans JP, Noto Sans SC, Helvetica, Arial, sans-serif`,
    },
    tooltip: {
        trigger: 'item',
        confine: true,
        transitionDuration: 0,
        extraCssText: 'box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.2)',
    },
    legend: {
        orient: 'horizontal',
        left: 0,
        bottom: 0,
        itemHeight: 8,
        itemWidth: 8,
        itemGap: 2,
        textStyle: {
            fontWeight: CHART_SMALL_FONT_WEIGHT,
            align: 'left',
            padding: [0, 20, 0, 0],
        },
        data: ([] as any[]),
    },
    series: ([] as any[]),
};

export const BASE_CHART_OPTIONS_MAPPER = {};

export const mapBaseColorOptions = (colorProvider: ColorProvider) => ({
    tooltip: {
        backgroundColor: colorProvider.tooltipBackgroundColor,
        textStyle: {
            color: colorProvider.tooltipTextColor,
        },
    },
    legend: {
        inactiveColor: colorProvider.legendInactiveColor,
        textStyle: {
            color: colorProvider.legendTextColor,
        },
    },
});
